(() => {
  const template = document.getElementById('ax-welcome-template');
  if (!template || !window.HTMLDialogElement || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
  const member = template.dataset.member;
  const key = member ? 'ax-welcome-v1-member-' + member : 'ax-welcome-v1-guest';
  const pendingKey = 'ax-welcome-login-pending';
  const read = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
  const write = (storage, name, value) => { try { window[storage].setItem(name, value); } catch {} };
  const pending = member && Date.now() - Number(read('sessionStorage', pendingKey) || 0) < 30 * 60000;
  if (!pending && (read('sessionStorage', key) || Date.now() - Number(read('localStorage', key) || 0) < 7 * 86400000)) return;
  let dialog, previousFocus, timer, attempts = 0;
  function dismiss() {
    if (dialog?.open) dialog.close();
  }
  function resume() { if (!document.hidden) show(); else document.addEventListener('visibilitychange', resume, {once:true}); }
  function show() {
    if (document.hidden) { document.addEventListener('visibilitychange', resume, {once:true}); return; }
    const occupied = document.querySelector('dialog[open],.mfp-wrap,.t4s-drawer__opened') || document.querySelector('.t4s-close-overlay:not(.t4s-op-0)');
    if (occupied) { if (++attempts < 8) timer = setTimeout(show, 1500); return; }
    document.body.append(template.content.cloneNode(true));
    dialog = document.getElementById('ax-welcome');
    if (!dialog) return;
    previousFocus = document.activeElement;
    dialog.querySelector('.ax-welcome-close').addEventListener('click', dismiss);
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) dismiss();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ax-welcome-open');
      write('localStorage', key, String(Date.now()));
      if (previousFocus?.isConnected && previousFocus !== document.body) previousFocus.focus({preventScroll:true});
      dialog.remove();
    }, {once:true});
    dialog.querySelector('.ax-welcome-login')?.addEventListener('click', () => {
      write('sessionStorage', pendingKey, String(Date.now()));
      dismiss();
    });
    dialog.querySelector('.ax-welcome-action:not(.ax-welcome-login)')?.addEventListener('click', dismiss);
    dialog.querySelector('.ax-welcome-copy')?.addEventListener('click', async () => {
      const input = dialog.querySelector('input');
      const status = dialog.querySelector('.ax-welcome-status');
      try {
        await navigator.clipboard.writeText(input.value);
        status.textContent = template.dataset.copied;
      } catch {
        input.focus(); input.select(); input.setSelectionRange(0, input.value.length);
        status.textContent = template.dataset.copyHelp;
      }
    });
    try {
      dialog.showModal();
      document.documentElement.classList.add('ax-welcome-open');
      write('sessionStorage', key, 'shown');
      if (member) write('sessionStorage', pendingKey, '0');
    } catch { dialog.remove(); }
  }
  timer = setTimeout(show, 1800);
  window.addEventListener('pagehide', () => { clearTimeout(timer); document.removeEventListener('visibilitychange', resume); document.documentElement.classList.remove('ax-welcome-open'); dismiss(); }, {once:true});
})();
